import { render, staticRenderFns } from "./Lightbox.vue?vue&type=template&id=7b4d709c"
import script from "./Lightbox.vue?vue&type=script&lang=js"
export * from "./Lightbox.vue?vue&type=script&lang=js"
import style0 from "./style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports